/**
 * Environment types supported by the application
 */
export enum Environment {
  DEVELOPMENT = 'development',
  STAGING = 'staging',
  MASTER = 'master',
  LOCAL = 'local',
  PRODUCTION = 'production',
  UNKNOWN = 'unknown'
}

/**
 * Determines the current environment based on the hostname
 * @returns The current environment
 */
export const getEnvironment = (): Environment => {
  const hostname = window.location.hostname;
  
  if (hostname.includes('develop')) {
    return Environment.DEVELOPMENT;
  } else if (hostname.includes('stage')) {
    return Environment.STAGING;
  } else if (hostname.includes('master')) {
    return Environment.MASTER;
  } else if (hostname.includes('localhost')) {
    return Environment.LOCAL;
  } else if (hostname.includes('app.silverbills.com')) {
    return Environment.PRODUCTION;
  } else {
    console.warn(`Unrecognized hostname: ${hostname}`);
    return Environment.UNKNOWN;
  }
};

/**
 * Checks if the current environment is a production environment
 * @returns True if the current environment is production
 */
export const isProduction = (): boolean => {
  return getEnvironment() === Environment.PRODUCTION;
};

/**
 * Checks if the current environment is a development environment (including local)
 * @returns True if the current environment is development or local
 */
export const isDevelopment = (): boolean => {
  const env = getEnvironment();
  return env === Environment.DEVELOPMENT || env === Environment.LOCAL;
};
